import { JSX, useContext } from "react";

import { RoleRestricted, Roles, UserContext } from "@app/user";
import MegaMenuHeader from "./MegaMenuHeader";
import MegaMenuStandardLink from "./MegaMenuStandardLink";

import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import MegaMenuLink from "./MegaMenuLink";

//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
export default function DownloadsMenu(): JSX.Element {
  const user = useContext(UserContext);

  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Downloads" />
        <ul className="menu">
          <RoleRestricted deniedRoles={[Roles.SOFTWARE_LICENSE]}>
            <MegaMenuLink menuItem={MenuItemEnum.Reports} faIcon="download" to="/reports" linkText="Reports" />
          </RoleRestricted>
          {(user.canDownload || null) && (
            <>
              <MegaMenuStandardLink menuItem={MenuItemEnum.Software} faIcon="save" to={`${window.uiEndpoint}/Support/Software`} linkText="Software" />
              <MegaMenuStandardLink menuItem={MenuItemEnum.Data} faIcon="file-archive-o" to={`${window.uiEndpoint}/Support/Data`} linkText="Data" />
            </>
          )}
        </ul>
      </li>
    </ul>
  );
}
